const promotionWatchers = new WeakMap();
const stopPromotionWatch = (section) => {
  window.clearInterval(promotionWatchers.get(section));
  promotionWatchers.delete(section);
};
const watchPromotions = (section) => {
  if (promotionWatchers.has(section)) return;
  promotionWatchers.set(section, window.setInterval(() => {
    if (!section.isConnected) {
      stopPromotionWatch(section);
    } else if ((window.shouldShowGiftBox() && section.querySelector('[data-gift-box-slide]'))
      || Array.from(section.querySelectorAll('[data-duo-slide]')).some((template) => window.shouldShowDuo(template.dataset.duoSlide))) {
      initProductHeroes(section);
    }
  }, 250));
};

const initProductHeroes = (root = document) => {
  const showGiftBox = window.shouldShowGiftBox();

  const sections = root.matches?.('[data-product-hero]') ? [root] : root.querySelectorAll('[data-product-hero]');
  sections.forEach((section) => {
    const element = section.querySelector('.swiper');
    if (!element || !window.Swiper) return;
    const giftBoxTemplates = section.querySelectorAll('[data-gift-box-slide]');
    const duoTemplates = section.querySelectorAll('[data-duo-slide]');
    const enabledDuoTemplates = Array.from(duoTemplates).filter((template) => window.shouldShowDuo(template.dataset.duoSlide));
    const swiper = element.swiper;
    const activeSlide = swiper?.slides[swiper.activeIndex];
    giftBoxTemplates.forEach((template) => {
      if (showGiftBox) template.replaceWith(template.content);
    });
    enabledDuoTemplates.forEach((template) => template.replaceWith(template.content));
    if (section.querySelector('[data-gift-box-slide], [data-duo-slide]')) watchPromotions(section);
    else stopPromotionWatch(section);
    if (swiper && !(showGiftBox && giftBoxTemplates.length) && !enabledDuoTemplates.length) return;
    const slides = element.querySelectorAll('.swiper-slide');
    section.style.display = slides.length ? '' : 'none';
    section.querySelectorAll('.hero-slider__dots, .hero-slider__arrow').forEach((control) => {
      control.style.display = slides.length > 1 ? '' : 'none';
    });
    if (!slides.length) return;

    slides.forEach((slide, index) => {
      const title = slide.querySelector('.title');
      const tagName = index === 0 ? 'H1' : 'H2';
      if (title && title.tagName !== tagName) {
        const heading = document.createElement(tagName);
        heading.className = title.className;
        heading.append(...title.childNodes);
        title.replaceWith(heading);
      }
      const image = slide.querySelector('.hero-slider__img img');
      if (image) {
        const isVisible = activeSlide ? slide === activeSlide : index === 0;
        image.loading = isVisible ? 'eager' : 'lazy';
        image.fetchPriority = isVisible ? 'high' : 'auto';
      }
    });
    if (swiper) {
      swiper.update();
      swiper.slideTo(Math.max(0, Array.from(slides).indexOf(activeSlide)), 0);
      swiper.slides.forEach((slide, index) => { slide.inert = index !== swiper.activeIndex; });
      return;
    }
    const dots = section.querySelector('.hero-slider__dots');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    new Swiper(element, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: reducedMotion ? 0 : 450,
      rewind: true,
      watchOverflow: true,
      navigation: {
        prevEl: section.querySelector('.hero-slider__arrow--left'),
        nextEl: section.querySelector('.hero-slider__arrow--right'),
      },
      pagination: {
        el: dots,
        clickable: true,
        bulletElement: 'button',
        bulletClass: 'hero-slider__dot',
        bulletActiveClass: 'hero-slider__dot--active',
      },
      a11y: {
        ...(section.querySelector('.hero-slider__arrow--left') ? { prevSlideMessage: section.querySelector('.hero-slider__arrow--left').getAttribute('aria-label') } : {}),
        ...(section.querySelector('.hero-slider__arrow--right') ? { nextSlideMessage: section.querySelector('.hero-slider__arrow--right').getAttribute('aria-label') } : {}),
        ...(dots?.dataset.slideLabel ? { paginationBulletMessage: dots.dataset.slideLabel } : {}),
      },
      on: {
        init(swiper) {
          swiper.slides.forEach((slide, index) => { slide.inert = index !== swiper.activeIndex; });
        },
        slideChange(swiper) {
          swiper.slides.forEach((slide, index) => { slide.inert = index !== swiper.activeIndex; });
        },
      },
    });
    const scrollButton = section.querySelector('.hero-slider__scroll');
    if (scrollButton) {
      scrollButton.onclick = () => {
        const next = section.closest('.shopify-section')?.nextElementSibling;
        next?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
      };
    }
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductHeroes(), { once: true });
} else {
  initProductHeroes();
}
document.addEventListener('shopify:section:load', (event) => initProductHeroes(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-product-hero]').forEach((section) => {
    stopPromotionWatch(section);
    section.querySelector('.swiper')?.swiper?.destroy(true, true);
  });
});
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('[data-product-hero] .swiper-slide');
  const swiper = slide?.closest('.swiper')?.swiper;
  if (swiper) swiper.slideTo(swiper.slides.indexOf(slide), 0);
});
